import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Icon, Input, message, Popconfirm, Breadcrumb, Empty, Button } from 'antd';
import Scrollbars from 'react-custom-scrollbars';
import PageTemplate from '../../../../components/pageTemplate/PageTemplate';
import ArticleTree from './components/articleTree/ArticleTree';
import ArticleView from './components/articleView/ArticleView';
import request from '../../../../../../base/request';
import { successCollect } from '../../components/successCollect/SuccessCollect';
import ChangeCollectFolder from '../../components/changeCollectFolder/ChangeCollectFolder';
import style from './wechatCollectArticle.module.css';
import download from './images/download.png';
import edit from './images/edit.png';
import deleteIcon from './images/delete.png';
import downLoadHis from './images/downloadHis.png';

const WechatCollectArticle = (props) => {
  const [allFolder, setAllFolder] = useState([]);
  const [selectFolder, setSelectFolder] = useState({});
  const [newFolder, setNewFolder] = useState({
    visible: false,
    name: ''
  });
  const [treeData, setTreeData] = useState([]);
  const [articleData, setArticleData] = useState({});
  // 修改文件夹位置显示条件
  const [changeCollectVisible, setChangeCollectVisible] = useState(false);

  // 选中的文章内容
  const [positionContent, setPositionContent] = useState({});
  // 鼠标悬浮时显示操作按钮
  const [hoverAction, setHoverAction] = useState({
    id: '',
    name: ''
  });
  // 表明编辑文件夹名称时，是否进行了修改
  const [isEdit, setIsEdit] = useState(false);

  useEffect(() => {
    const folderIds = Object.keys(newFolder);
    const filterId = folderIds.filter((item) => {
      return newFolder[item].visible;
    });
    const currentId = filterId[filterId.length - 1];
    const currentEle = document.getElementById(currentId);
    if(currentId && currentEle) {
        currentEle.focus();
    }
  }, [newFolder]);
  const liClick = useCallback((id, name) => {
    setSelectFolder({
      id, name
    });
    request({
      url: '/cm-sites-media-consumer/collect/articleList',
      method: 'get',
      body: {
        typeId: id
      },
      callBack: (data) => {
        if (data) {
          data.forEach((item) => {
            item.articleList.forEach((article) => {
              article.collectFolderId = id;
              article.collectFolderName = name;
            })
          });
          setTreeData(data);
        }
      }
    })
  }, []);
  // 所有收藏夹
  const getAllCollectFolder = useCallback((folderId, folderName) => {
    request({
      url: "/cm-sites-media-consumer/collect/collectiontypeList",
      callBack: (data) => {
        setAllFolder(data);
        const defaultFolder = data && data.find((item) => {
          return item.stats === 0;
        });
        if (folderId && folderName) {
          liClick(folderId, folderName);
        } else {
          defaultFolder?.id && liClick(defaultFolder.id, defaultFolder.name);
        }
      },
      errorCallBack: (err) => {
      }
    })
  }, []);
  // 新增收藏夹
  const submitNewFolder = useCallback((id) => {
    if (!newFolder[id].name) {
      message.destroy();
      message.error('请输入收藏夹名称');
      return;
    }
    if (!isEdit) {
      message.destroy();
      message.warning('未作任何修改');
      setNewFolder((prev => {
        return {
          ...prev,
          [id]: {
            visible: false,
            name: ''
          }
        }
      }))
      return
    }
    const filterArray = allFolder.filter((item) => {
      return item.name === newFolder[id].name;
    });
    const updateFolder = allFolder.filter((item) => {
      return item.id === id;
    });
    if (filterArray.length) {
      message.destroy();
      message.warn('收藏夹名称重复');
    } else {
      const params = updateFolder[0] ? { ...updateFolder[0], name: newFolder[id].name } : { name: newFolder[id].name };
      request({
        url: '/cm-sites-media-consumer/collect/saveCollectType',
        method: 'post',
        contentType: 'json',
        body: params,
        callBack: (res) => {
          if (res.id && res.name) {
            message.destroy();
            message.success(updateFolder[0] ? '修改成功' : '新建成功');
            getAllCollectFolder(res.id, res.name);
            setNewFolder({
              [id]: {
                visible: false,
                name: ''
              }
            });
          }
        }
      });
    }
  }, [newFolder, allFolder]);

  // 修改文件夹名称
  const editFolderName = useCallback((id, oldName) => {
    setNewFolder((prev) => {
      return {
        ...prev,
        [id]: {
          name: oldName,
          visible: true
        }
      }
    })
  }, []);

  // 删除文件夹
  const deleteFolder = useCallback((id) => {
    request({
      url: '/cm-sites-media-consumer/collect/deleteCollectType',
      method: 'get',
      body: {
        id
      },
      callBack: () => {
        message.destroy();
        message.success('删除成功');
        getAllCollectFolder();
      }
    })
  });

  const newFolderInput = useCallback((id) => {
    return (
      <>
        <Input
          id={id}
          maxLength={20}
          value={newFolder[id].name}
          style={{ width: 165 }}
          size='small'
          onChange={(e) => {
            setIsEdit(true);
            const name = e.target.value;
            setNewFolder((prev) => {
              return {
                ...prev,
                [id]: {
                  ...newFolder[id],
                  name
                }
              }
            })
          }}
          onClick={(e) => {
            e.stopPropagation();
          }}
        />
        <div onClick={(e) => {
          e.stopPropagation();
        }}>
          <a style={{ color: '#0050B3', fontSize: 14 }} onClick={() => { submitNewFolder(id); setIsEdit(false); }}>确定</a>
          <a style={{ marginLeft: 10, color: '#ccc', fontSize: 14 }} onClick={() => {
            setIsEdit(false);
            setNewFolder((prev => {
              return {
                ...prev,
                [id]: {
                  visible: false,
                  name: ''
                }
              }
            }))
          }}>取消</a>
        </div>
      </>
    )
  }, [newFolder]);

  // 选中树结构中文章
  const selectArticle = useCallback((id) => {
    const res = treeData.map(item => {
      if (Array.isArray(item.articleList)) {
        return item.articleList.find(article => article.id == id) || null;
      }
      return null;
    }).filter(article => article !== null);
    if (res.length) {
      const { collectFolderId, collectFolderName, positionContentVo } = res[0];
      const { contentId, positionTypeId } = positionContentVo || {};
      if (positionContentVo) {
        setPositionContent(positionContentVo);
      }
      request({
        url: '/cm-sites-media-consumer/position/content/manager/getById',
        method: 'get',
        body: {
          contentId,
          typeId: positionTypeId
        },
        callBack: (data) => {
          if (data.cmSiteContent) {
            setArticleData({
              positionContentVo,
              collectFolderId,
              collectFolderName,
              cmSiteContent: data.cmSiteContent
            })
          }
        }
      })
    }
  }, [treeData]);

  // 移除收藏
  const cancelCollect = useCallback(({ contentId, collectFolderId, collectFolderName, callBack }) => {
    request({
      url: '/cm-sites-media-consumer/collect/deleteCollectArticleInType',
      method: 'post',
      contentType: 'json',
      body: {
        contentId,
        collectTypeIds: [collectFolderId]
      },
      callBack: () => {
        message.destroy();
        message.success('取消收藏成功');
        getAllCollectFolder(collectFolderId, collectFolderName);
        // liClick(collectFolderId, collectFolderName);
        callBack && callBack();
      }
    })
  }, [allFolder]);

  // 收藏功能
  const saveArticle = useCallback(({ collectTypeIds, positionContentVo, collectFolderId, collectFolderName, callBack }) => {
    if (!collectTypeIds || !collectTypeIds.length) {
      collectTypeIds = [allFolder.length && allFolder.find(item => item.stats === 0).id];
    }
    if (!positionContentVo) {
      positionContentVo = positionContent;
    }
    request({
      url: "/cm-sites-media-consumer/collect/saveCollectArticle",
      method: "post",
      contentType: 'json',
      body: {
        collectTypeIds,
        positionContentVo
      },
      callBack: (res) => {
        if (res.id) {
          if (!changeCollectVisible) {
            successCollect(() => {
              setChangeCollectVisible(true);
            })
          }
          getAllCollectFolder();
          if (collectFolderId && collectFolderName) {
            liClick(collectFolderId, collectFolderName);
          }
          callBack();
        }
      }
    })
  }, [allFolder]);

  // 移除所有收藏夹内文章
  const deleteCollectionArticle = (articleId) => {
    request({
      url: "/cm-sites-media-consumer/collect/deleteCollectArticle",
      method: "get",
      body: {
        articleId: articleId ? articleId : positionContent.contentId
      },
      callBack: (res) => {
        if (res) {
          message.destroy();
          message.success("已取消收藏");
          setArticleData((prev) => {
            return {
              ...prev,
              positionContentVo: {
                ...prev.positionContentVo,
                collect: false
              }
            }
          })
          getAllCollectFolder();
        }
      }
    })
  }

  // 下载所有文章
  const downloadAll = useCallback(async (id, name) => {
    // 获取文件夹下所有文章
    const downloadArticleData = await new Promise(resolve => {
      request({
        url: '/cm-sites-media-consumer/collect/articleList',
        method: 'get',
        body: {
          typeId: id
        },
        callBack: (data) => {
          if (data) {
            resolve(data);
          }
        }
      })
    });
    const params = downloadArticleData.reduce((prev, curr) => {
      const listResult = curr.articleList.reduce((list, art) => {
        list.typeId = art.positionContentVo.positionTypeId;
        list.downloadIds.push(art.positionContentVo.contentId);
        return list;
      }, { typeId: '', downloadIds: [] });
      prev.typeId = listResult.typeId;
      prev.downloadIds = prev.downloadIds.concat(listResult.downloadIds);
      return prev;
    }, { typeId: '', downloadIds: [] });
    request({
      url: '/cm-sites-media-consumer/position/content/manager/downloadByIds',
      body: {
        ...params,
        downloadIds: params.downloadIds.join(',')
      },
      method: "post",
      callBack: (res) => {
        if (res.indexOf('下载成功') > -1) {
          message.destroy();
          message.success({
            content: <span>文件压缩包正在生成中，请点击右上角<img style={{width: 20, transform: 'translateY(-2px)'}} src={downLoadHis} />查看</span>,
            duration: 3,
          });
        }
      },
      errorCallBack: (e) => {
      },
    })
  }, [allFolder]);
  useEffect(() => {
    getAllCollectFolder();
  }, []);
  return (
    <PageTemplate style={{ height: 'calc(100vh - 100px)', padding: 0 }}>
      <div className={style.container}>
        <div className={style.allFolder}>
          <Scrollbars style={{ height: '100%' }} autoHide width={'100%'}>
            <div style={{ display: 'flex', justifyContent: 'space-between', height: 42, alignItems: 'center', paddingLeft: 10, paddingRight: 10 }}>
              <h1 style={{ fontSize: '20px', fontWeight: 400, color: '#222222', marginBottom: 0 }}>收藏夹</h1>
              <Icon type='plus' style={{ color: '#1890ff', cursor: 'pointer' }} onClick={() => {
                setNewFolder({
                  "createNewFolder": {
                    visible: true,
                    name: ''
                  }
                })
              }} />
            </div>
            <ul className={style.ulClass}>
              {
                allFolder?.map((item) => {
                  return (
                    <li
                      key={item.id}
                      onClick={() => {
                        liClick(item.id, item.name);
                      }}
                      // onMouseEnter={() => {
                      //   setHoverAction({
                      //     id: item.id,
                      //     name: item.name
                      //   })
                      // }}
                      // onMouseLeave={() => {
                      //   setHoverAction({
                      //     id: '',
                      //     name: ''
                      //   })
                      // }}
                      className={item.id === selectFolder.id ? `${style.liActive} ${style.liClass}` : `${style.liClass}`}
                    >
                      {
                        newFolder[item.id]?.visible ? newFolderInput(item.id) :
                          <>
                            <div style={{ maxWidth: '150px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                              <div style={{ flex: 'auto', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', }}>
                                {item.name}
                              </div>
                              <div style={{ width: 30 }}>
                                （{item.articleNum}）
                              </div>
                            </div>
                            {(item.id === selectFolder.id || hoverAction.id === item.id) &&
                              <div onClick={(e) => {
                                e.stopPropagation();
                              }}>
                                {/* <img className={style.actionIcon} src={download} onClick={() => {
                                  if (item.articleNum > 0) {
                                    downloadAll(item.id, item.name);
                                  } else {
                                    message.destroy();
                                    message.warning('暂无内容不可下载');
                                  }
                                }}></img> */}
                                {
                                  item.stats !== 0 &&
                                  <img className={style.actionIcon} src={edit} onClick={() => {
                                    editFolderName(item.id, item.name);
                                  }}></img>
                                }
                                <Popconfirm title='该操作会导致收藏夹下所有文章都被删除，请确认' onConfirm={() => {
                                  deleteFolder(item.id)
                                }}>
                                  {item.stats !== 0 && <img className={style.actionIcon} src={deleteIcon}></img>}
                                </Popconfirm>
                              </div>
                            }
                          </>
                      }
                    </li>
                  )
                })
              }
              {newFolder["createNewFolder"]?.visible &&
                <li className={style.liClass}>
                  {(newFolderInput("createNewFolder"))}
                </li>
              }
            </ul>
          </Scrollbars>
        </div>
        <div className={style.articleContainer}>
          <div className={style.articleNav}>
            <div style={{ color: '#222222', fontSize: '16px', fontWeight: 400 }}>
              {selectFolder.name}
            </div>
            <div>
              <Breadcrumb>
                <Breadcrumb.Item>内容管理</Breadcrumb.Item>
                <Breadcrumb.Item>
                  <span style={{ color: '#000000', fontSize: '14px', fontWeight: 400 }}>收藏夹</span>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                  <a onClick={() => {
                    props.history.push('/newMedia/contentManagement');
                  }} style={{ color: '#0050B3' }}>返回上一级</a>
                </Breadcrumb.Item>
              </Breadcrumb>
            </div>
          </div>
          <div className={style.articleContentContainer}>
            {treeData.length ?
              <>
                <div className={style.articleList}>
                  <Scrollbars style={{ height: '100%' }} autoHide width={'100%'}>
                    <ArticleTree data={treeData} selectHandler={selectArticle} cancelCollect={cancelCollect} />
                  </Scrollbars>
                </div>
                <div className={style.articleContent}>
                  <ArticleView allFolder={allFolder} data={articleData} cancelCollect={cancelCollect} saveArticle={saveArticle} />
                </div>
              </> : <Empty image={<img src='images/noData.png' style={{ width: 300, height: 225 }} />} imageStyle={{ transform: 'translateY(-140px)' }} description={'暂无内容，快去收藏吧'} style={{ width: '100%' }}>
                <Button onClick={() => {
                  props.history.push('/newMedia/contentManagement');
                }}>去收藏</Button>
              </Empty>}
          </div>
        </div>
      </div>
      <ChangeCollectFolder visible={changeCollectVisible} data={allFolder} cancel={() => {
        setChangeCollectVisible(false);
      }} refreshData={getAllCollectFolder} saveArticle={saveArticle} cancelCollect={deleteCollectionArticle} />
    </PageTemplate >
  )
}

export default WechatCollectArticle;